import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';
import styled from 'styled-components';

import layoutConfig from 'components/Brochure/layoutConfig';
import { generateId } from 'lib/styles';
import Modal from 'components/Modal';

import {
	Wrapper,
	Page,
	Description,
} from './styles';

import {
	GhostButton,
} from 'lib/styles';

const NewPageButton = styled(Link)`
  color: white;
  padding: 16px 32px;
  margin: 0;
  border: 0px;
  border-radius: 4px;
  text-align: center;
  display: block;
  justify-content: center;
  background-color: rgb(51, 51, 51);
  font-size: 18px;
	font-weight: 200;
	text-decoration: none;
  cursor: pointer;
  transition: background-color 0.2s ease-out, box-shadow 0.2s ease-out, transform 0.2s ease-out;
  outline: none;
  user-select: none;

  &:hover,
	&:focus,
	&:active {
    background-color: rgb(77, 77, 77);
  }
`;

class PageSelect extends React.Component {
	state = {
	  selectedLayout: Object.keys(layoutConfig)[0],
	}

	layoutSelectHandler = selectedLayout => {
	  this.setState({ selectedLayout });
	}

	addPageHandler = () => {
	  this.props.addPageHandler(this.state.selectedLayout);
	  this.props.closeHandler();
	}

	render() {
	  const { t, lng: language, brochureType } = this.props;
	  const templates = Object.keys(layoutConfig).filter(layoutKey => layoutConfig[layoutKey].allowedBrochureTypes.indexOf(brochureType) > -1).map(layoutKey => {
	    const layout = layoutConfig[layoutKey];
	    const Layout = layout.thumbnail;
	    const slotCount = layout.allowedComponents.length;
	    const slot = Array.from(Array(slotCount)).map(() => ({
	      type: 'blank',
	      data: [],
	      layout: 'default',
	    }));
	    const active = layoutKey === this.state.selectedLayout;

	    return (
	      <Page
	        key={layoutKey}
	        active={active ? 1 : 0}
	        onClick={() => this.layoutSelectHandler(layoutKey)}
	      >
	        <Layout slot={slot} />
	        <Description>{ t('layout/' + layoutKey) }</Description>
	      </Page>
	    )
	  });
	  const newPageId =  generateId();


	  return (
	    <Modal
	      header={t('brochure/Page select/Choose template')}
	      body={(
	        <Wrapper>
	          { templates }
	        </Wrapper>
	      )}
	      footer={(
	        <React.Fragment>
	          <GhostButton onClick={this.props.closeHandler}>{t('brochure/Page select/Close')}</GhostButton>
	          <NewPageButton to={{
	            pathname: `/${language}/t/brochure/${this.props.brochureId}/${newPageId}/`,
	            state: { ...this.state },
	          }}>{t('brochure/Page select/Add page')}</NewPageButton>
	        </React.Fragment>
	      )}
	    />
	  );
	}
}

PageSelect.propTypes = {
	t: PropTypes.func,
	lng: PropTypes.string,
	brochureId: PropTypes.string,
	brochureType: PropTypes.string,
	pages: PropTypes.array,
	closeHandler: PropTypes.func,
	addPageHandler: PropTypes.func,
}

export default translate('translations')(PageSelect)
